import axios from 'axios';
const HOSTAPI = process.env.REACT_APP_BASE_URL;

export const fetchPollResults = async (pollId: string) => {
    try {
        const response = await axios.get(`${HOSTAPI}/poll/${pollId}/results`);
        if (response.data.status === 'success') {
            return response.data;
        } else {
            throw new Error('Failed to fetch slides');
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
};
